module.exports = __webpack_public_path__ + "img/right_bg2.af8d7d2.png";